import NavBar from "./NavBar";

function Header(){
    return (<header className="fixed-top header">
      <NavBar />
    </header>);
}
export default Header